import {TEST} from "../actions/test";

function storeTestMiddleware(test) {
    localStorage.setItem("running_test", JSON.stringify(test));
    return test;
}

const defaults = {
    dialog_open: false,
    visible_character_boxes: false,
    randomize_row_order: true,
    case_sensitivity: true,
    test_type: "choice",
    cluster_id: null,
    state: TEST.NOT_RUNNING,
    source_col: 1, //0
    target_col: 2, //0
    target_col2: 0, // 0
    answer: "",
    answer2: "",
    time_for_answer: null,
    questions: [],
    current_question: 0,
    scores: [],
    evaluating: false,
    from_last_answers: false,
    last_wrong_answers: {},
    questions_at_start: null,
    col_names: []
};

const testReducer = (state, action) => {
    if (state === undefined) {
        if (localStorage.getItem("running_test") === null) {
            return {...defaults};
        } else {
            const running_test = JSON.parse(localStorage.getItem("running_test"));
            if (running_test.state === TEST.RUNNING || running_test.state === TEST.PAUSED) {
                return running_test;
            } else return storeTestMiddleware({
                ...defaults,
                source_col: running_test.source_col,
                target_col: running_test.target_col,
                time_for_answer: running_test.time_for_answer,
                visible_character_boxes: running_test.visible_character_boxes,
                randomize_row_order: running_test.randomize_row_order,
                case_sensitivity: running_test.case_sensitivity,
                test_type: running_test.test_type,
                last_wrong_answers: running_test.last_wrong_answers
            }); // reset test
        }
    }
    switch (action.type) {
        // config
        case "OPEN_TEST_DIALOG":
            return {
                ...state,
                dialog_open: true,
                cluster_id: action.cluster_id,
            };
        case "CLOSE_TEST_DIALOG":
            return {
                ...state,
                dialog_open: false
            };
        case "SET_TEST_CLUSTER":
            return {
                ...state,
                cluster_id: parseInt(action.cluster_id)
            };
        case "SET_SOURCE_COL":
            return storeTestMiddleware({
                ...state,
                source_col: parseInt(action.source_col)
            });
        case "SET_TARGET_COL":
            return storeTestMiddleware({
                ...state,
                target_col: parseInt(action.target_col)
            });
        case "SET_TARGET_COL2":
            return {
                ...state,
                target_col2: parseInt(action.target_col2)
            };
        case "SET_COL_NAMES":
            return storeTestMiddleware({
                ...state,
                col_names: action.col_names
            });
        case "SET_TIME_FOR_ANSWER":
            return storeTestMiddleware({
                ...state,
                time_for_answer: action.timing
            });

        case "SET_CHARACTER_BOXES_VISIBILITY":
            return storeTestMiddleware({
                ...state,
                visible_character_boxes: action.visible
            });

        case "SET_RANDOMIZE_ROW_ORDER":
            return storeTestMiddleware({
                ...state,
                randomize_row_order: action.randomize
            })
        case "SET_CASE_SENSITIVITY":
            return storeTestMiddleware({
                ...state,
                case_sensitivity: action.activate
            })
        case "SET_TEST_TYPE":
            return storeTestMiddleware({
                ...state,
                test_type: action.value
            })
        case "SET_FROM_LAST_ANSWERS":
            return {
                ...state,
                from_last_answers: action.from_last_answers
            }
        case "RESET_TEST":
            const {
                last_wrong_answers,
                visible_character_boxes,
                randomize_row_order,
                case_sensitivity,
                time_for_answer,
                ...defaults_without
            } = defaults;
            return storeTestMiddleware({
                last_wrong_answers: state.last_wrong_answers,
                visible_character_boxes: state.visible_character_boxes,
                randomize_row_order: state.randomize_row_order,
                case_sensitivity: state.case_sensitivity,
                time_for_answer: state.time_for_answer,
                test_type: state.test_type,
                ...defaults_without
            });

        case "START_TEST":
            return storeTestMiddleware({
                ...state,
                state: TEST.RUNNING,
                dialog_open: false
            });
        case "FINISH_TEST":
            return storeTestMiddleware({
                ...state,
                state: TEST.FINISHED
            });
        case "SET_ANSWER":
            return {
                ...state,
                answer: action.answer
            };
        case "SET_ANSWER2":
            return {
                ...state,
                answer2: action.answer
            };
        case "SET_QUESTIONS":
            return storeTestMiddleware({
                ...state,
                questions: action.rows
            });
        case "INIT_QUESTIONS":
            return storeTestMiddleware({
                ...state,
                questions: action.rows,
                questions_at_start: action.rows.length,
                current_question: 0,
                scores: [],
                evaluating: false,
            });
        case "NEXT_QUESTION":
            return storeTestMiddleware({
                ...state,
                answer: "",
                answer2: "",
                current_question: state.current_question + 1,
                evaluating: false
            });
        case "SCORE_ANSWER":
            return storeTestMiddleware({
                ...state,
                scores: [...state.scores, action.score],
                evaluating: true
            });
        case "START_TIMER":
            return {
                ...state,
                baseTime: action.baseTime,
                startedAt: action.now,
                stoppedAt: undefined
            };
        case "STOP_TIMER":
            return {
                ...state,
                stoppedAt: action.now
            };
        case "PAUSE_TEST":
            return storeTestMiddleware({
                ...state,
                state: TEST.PAUSED
            });
        case "RESUME_TEST":
            return storeTestMiddleware({
                ...state,
                state: TEST.RUNNING
            });
        case "RESET_TIMER":
            return {
                ...state,
                baseTime: 0,
                startedAt: state.startedAt ? action.now : undefined,
                stoppedAt: state.stoppedAt ? action.now : undefined
            };
        case "STORE_WRONG_ANSWERS":
            return storeTestMiddleware({
                ...state,
                last_wrong_answers: {
                    ...state.last_wrong_answers,
                    [action.cluster_id]: [...action.answers]
                }
            });
        default:
            return state
    }
};
export default testReducer;
